// extracted by mini-css-extract-plugin
export default {"container":"BQ","productarea":"CQ","btn":"EQ","promowrapper":"FQ","upsellarea":"GQ","subtitle":"HQ","system":"IQ","desc":"JQ","cardswrap":"KQ","cards":"LQ","squareloadingcontainer":"MQ","squareloading33":"NQ"};
    if(module.hot) {
      // 1715276859161
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  